(() => {
  const GALLERY_SELECTOR = 'main[data-template="product"] media-gallery';

  function pauseVideos(root) {
    root.querySelectorAll('video').forEach((v) => {
      try { v.pause(); } catch (_) {}
    });
  }

  function isInViewport(el, threshold = 0.25) {
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    const ratio = visible / Math.max(r.height, 1);
    return ratio >= threshold;
  }

  function ensureDeferredMediaLoaded(activeSlide) {
    // If Horizon uses <deferred-media>, the <video> may not exist until the poster button is clicked.
    const deferred = activeSlide.querySelector('deferred-media');
    if (!deferred) return false;

    // If a video already exists, we're good.
    if (activeSlide.querySelector('video')) return true;

    const btn =
      deferred.querySelector('button[ref="deferredMediaPlayButton"]') ||
      deferred.querySelector('.deferred-media__poster-button');

    if (btn) {
      btn.click();
      return true;
    }
    return false;
  }

  function playActiveVideo(gallery) {
    const activeSlide =
      gallery.querySelector('slideshow-slide[aria-hidden="false"]') ||
      gallery.querySelector('slideshow-slide:not([aria-hidden="true"])');

    // Pause videos in non-active slides no matter what.
    gallery.querySelectorAll('slideshow-slide').forEach((slide) => {
      if (slide !== activeSlide) {
        slide.querySelectorAll('video').forEach((v) => {
          try { v.pause(); } catch (_) {}
        });
      }
    });

    if (!activeSlide) return;

    // If it's deferred, trigger load
    const didTrigger = ensureDeferredMediaLoaded(activeSlide);

    // Try to play (immediately, and again shortly if we just triggered deferred load)
    const tryPlay = () => {
      const v = activeSlide.querySelector('video');
      if (!v) return;

      // enforce autoplay-safe settings
      v.muted = true;
      v.playsInline = true;
      v.autoplay = true;
      v.loop = true;

      const p = v.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    };

    tryPlay();
    if (didTrigger) setTimeout(tryPlay, 150);
  }

  function initGallery(gallery) {
    if (gallery.__mifVideoVisibility) return;
    gallery.__mifVideoVisibility = true;

    // Pause/Play based on scrolling visibility of the gallery itself
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.target !== gallery) continue;
          if (entry.isIntersecting) playActiveVideo(gallery);
          else pauseVideos(gallery);
        }
      },
      { threshold: 0.25 }
    );
    io.observe(gallery);

    // When slide changes (aria-hidden flips), pause old / play new (only if gallery is visible)
    const mo = new MutationObserver((mutations) => {
      let slideChanged = false;
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
          slideChanged = true;
          break;
        }
      }
      if (!slideChanged) return;

      if (isInViewport(gallery, 0.25)) playActiveVideo(gallery);
      else pauseVideos(gallery);
    });

    const slidesHost = gallery.querySelector('slideshow-slides') || gallery;
    mo.observe(slidesHost, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });

    // If user switches tabs, pause everything
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pauseVideos(gallery);
      else if (isInViewport(gallery, 0.25)) playActiveVideo(gallery);
    });

    // First run
    if (isInViewport(gallery, 0.25)) playActiveVideo(gallery);
  }

  function boot() {
    document.querySelectorAll(GALLERY_SELECTOR).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor / dynamic loads
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
